import { createSelector } from 'reselect';
import { getReferenceDataCriteriaArguments } from '../../../../containers/base-filter-bar-container/reference-data-criteria-arguments';

const getCriteriaArguments = createSelector(
  (state) => getReferenceDataCriteriaArguments(state),
  (referenceDataCriteriaArguments) => ({
    ...referenceDataCriteriaArguments,
  }),
);

export default getCriteriaArguments;
